module.exports = __webpack_public_path__ + "img/02.c46d195d.png";